export default __webpack_public_path__ + "static/media/how_it_works_2.e608d0b0.png";